module.exports = __webpack_public_path__ + "img/chapelbell-v-474x632.5d042e20.jpg";